import RestClient from './rest-client'

export default class Carrier extends RestClient {
  static get url () {
    return this.apiUrl + '/carriers'
  }

  static get paramKey () {
    return 'carrier'
  }

  static async saveFormData (id, formData) {
    if (id) {
      const { data } = await this._put(`${this.url}/${id}`, formData)
      return data
    } else {
      const { data } = await this._post(this.url, formData)
      return data
    }
  }

  static async export (params) {
    const { data } = await this.http({
      url: this.url + '/export',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }

  static async fromShipments () {
    const { data } = await this._get(this.url + '/from_shipments')
    if (!data || !data.data) { return [] }

    return data.data.map(o => new this(o))
  }

  static async uploadFile (formData) {
    const { data } = await this._post(this.url + '/upload', formData)
    return data
  }

  static async exportCarrierInfo (id) {
    const { data } = await this.http({
      url: `${this.url}/${id}/export_info`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })
    return data
  }

  static async downloadXML (id) {
    const { data } = await this.http({
      url: `${this.url}/${id}/download_xml`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })
    return data
  }

  static async uploadShipmentXML (formData, id) {
    const { data } = await this.http({
      url: `${this.url}/${id}/upload_shipment_xml`,
      data: formData,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })
    return data
  }

  static async downloadLabelPdf (id) {
    const { data } = await this.http({
      url: `${this.url}/${id}/download_label_pdf`,
      method: 'POST',
      responseType: 'blob',
      headers: this.headers
    })

    return data
  }

  static async clientAgreements (payload) {
    const { data } = await this._post(this.url + '/client_agreements', payload)

    return data
  }

}
